export default {
  path: '/office/warehouse',
  component: () => import('@/layout/office/index.vue'),
  redirect: '/office/warehouse/dashboard',
  name: 'Warehouse',
  meta: { title: '仓库管理', icon: 'box', requiresAuth: true, moduleType: 'OFFICE' },
  children: [
    {
      path: 'dashboard',
      name: 'WarehouseDashboard',
      component: () => import('@/views/warehouse/Dashboard.vue'),
      meta: { title: '总览' }
    },
    {
      path: 'stock',
      redirect: '/office/warehouse/stock/list',
      meta: { title: '库存' },
      children: [
        {
          path: 'list',
          name: 'InventoryList',
          component: () => import('@/views/warehouse/stock/InventoryList.vue'),
          meta: { title: '库存明细' }
        },
        {
          path: 'history',
          name: 'InventoryHistory',
          component: () => import('@/views/warehouse/stock/InventoryHistory.vue'),
          meta: { title: '库存流水' }
        },
        {
          path: 'adjust',
          name: 'InventoryAdjust',
          component: () => import('@/views/warehouse/stock/InventoryAdjust.vue'),
          meta: { title: '库存调整' }
        },
        {
          path: 'reserve',
          name: 'InventoryReserve',
          component: () => import('@/views/warehouse/stock/ReserveOperation.vue'),
          meta: { title: '锁定/解锁库存' }
        }
      ]
    },
    {
      path: 'item-list',
      name: 'ItemList',
      component: () => import('@/views/office/warehouse/item-list.vue'),
      meta: { title: '物品管理' }
    },
    {
      path: 'item-categories',
      name: 'ItemCategories',
      component: () => import('@/views/office/warehouse/item-categories.vue'),
      meta: { title: '物品类别管理' }
    },
    {
      path: 'suppliers',
      name: 'Suppliers',
      component: () => import('@/views/office/warehouse/suppliers.vue'),
      meta: { title: '供应商管理' }
    },
    {
      path: 'warehouses',
      name: 'WarehouseList',
      component: () => import('@/views/warehouse/WarehouseList.vue'),
      meta: { title: '仓库列表' }
    },
    {
      path: 'warehouses/create',
      name: 'CreateWarehouse',
      component: () => import('@/views/office/warehouse/create.vue'),
      meta: { title: '新增仓库', hideInMenu: true }
    },
    {
      path: 'warehouses/:id/edit',
      name: 'EditWarehouse',
      component: () => import('@/views/office/warehouse/edit.vue'),
      meta: { title: '编辑仓库', hideInMenu: true }
    },
    {
      path: 'stock-orders',
      name: 'StockOrders',
      component: () => import('@/views/warehouse/stock-orders/Index.vue'),
      meta: { title: '出入库管理' }
    },
    {
      path: 'stock-orders/:id',
      name: 'StockOrderDetail',
      component: () => import('@/views/warehouse/stock-orders/Detail.vue'),
      meta: { title: '出入库详情', hideInMenu: true }
    },
    {
      path: 'stock-orders/:id/edit',
      name: 'StockOrderEdit',
      component: () => import('@/views/warehouse/stock-orders/Edit.vue'),
      meta: { title: '编辑出入库单', hideInMenu: true }
    }
  ]
};

